import { useTranslation } from 'react-i18next';

import { Card, CardContent } from '@/components/ui/card';
import { IntercomIntegration } from '@/shared/types/integration';

interface RowProps {
  label: string;
  value?: string;
}

const Row = ({ label, value }: RowProps) => (
  <div className="flex items-start gap-4">
    <dt className="flex-1 text-muted-foreground">{label}</dt>
    <dd>{value || '—'}</dd>
  </div>
);

export const ConnectionInfoCard = ({ integration }: { integration: IntercomIntegration }) => {
  const { t } = useTranslation();

  return (
    <Card className="rounded-md border-border py-0 shadow-none">
      <CardContent className="flex flex-col gap-4 px-4 pt-4 pb-5 text-sm leading-5 font-medium">
        <p>{t('integrations.intercom.connection_info')}</p>
        <dl className="flex flex-col gap-3">
          <Row
            label={t('integrations.intercom.workspace_name')}
            value={integration.config?.page_name}
          />
          <Row
            label={t('integrations.intercom.assigned_agent')}
            value={integration.config?.admin_name}
          />
        </dl>
      </CardContent>
    </Card>
  );
};
